import { render, staticRenderFns } from "./normalModule.vue?vue&type=template&id=553faf6b"
import script from "./normalModule.vue?vue&type=script&lang=js"
export * from "./normalModule.vue?vue&type=script&lang=js"
import style0 from "./normalModule.vue?vue&type=style&index=0&id=553faf6b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports